module.exports = __webpack_public_path__ + "img/mobile-xacnhan.45336fd1.png";